import { z } from 'zod';
/**
 * Corps de `POST /call-sheet` (fiche d'appel saisie depuis le backoffice).
 * `callDate` accepte aussi bien la chaîne ISO envoyée par le front qu'un
 * `Date`, comme l'attend Prisma. `notes` et `actions` restent facultatifs et
 * nullables : le formulaire les envoie vides quand l'admin ne les remplit pas.
 */
export const createCallSheetSchema = z.object({
    clientId: z.string().min(1),
    callSheet: z.object({
        // `.default(null)` sur `actions`/`notes` : les champs restent facultatifs
        // côté requête, mais la sortie est toujours définie — c'est ce qu'attend
        // `CallSheetCreateInput`.
        actions: z.string().nullish().default(null),
        callDate: z.union([z.string().min(1), z.date()]),
        notes: z.string().nullish().default(null),
        title: z.string().min(1).max(255),
    }),
});
